/* Testimonials carousel: theme-like sliding animation for the Judge.me
   widget. The widget lazy-loads its own carousel CSS on first interaction
   which overrides theme styleshemet rules, so positions are applied as
   inline !important styles — those always win. */
(function () {
  'use strict';

  var MQ = '(min-width: 990px)';
  var EASE = 'translate 0.55s cubic-bezier(0.33, 1, 0.68, 1), opacity 0.55s ease';

  /* the widget's own CSS fights over `transform`, so the standalone
     `translate` property is used instead — nothing overrides it */
  function apply(card, translate, opacity, z) {
    card.style.setProperty('transition', EASE, 'important');
    card.style.setProperty('translate', translate, 'important');
    card.style.setProperty('opacity', opacity, 'important');
    card.style.setProperty('z-index', z, 'important');
    card.style.setProperty('pointer-events', opacity === '1' ? 'auto' : 'none', 'important');
  }

  function clear(card) {
    ['transition', 'translate', 'opacity', 'z-index', 'pointer-events'].forEach(function (p) {
      card.style.removeProperty(p);
    });
    card.removeAttribute('data-mns-pos');
  }

  function update(container) {
    var cards = Array.prototype.slice.call(container.querySelectorAll('.jdgm-card'));
    if (!cards.length) return;

    if (!window.matchMedia(MQ).matches) {
      cards.forEach(clear);
      return;
    }

    var active = -1;
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].classList.contains('active')) { active = i; break; }
    }
    if (active < 0) return;

    var n = cards.length;
    cards.forEach(function (card, j) {
      var pos = 'hidden';
      if (j === active) pos = 'center';
      else if (j === (active - 1 + n) % n) pos = 'left';
      else if (j === (active + 1) % n) pos = 'right';
      card.setAttribute('data-mns-pos', pos);
      if (pos === 'center') apply(card, '0', '1', '2');
      else if (pos === 'left') apply(card, '-80%', '0.35', '1');
      else if (pos === 'right') apply(card, '80%', '0.35', '1');
      else apply(card, '0', '0', '0');
    });
  }

  function init() {
    var container = document.querySelector('.jdgm-testimonials-carousel .jdgm-testimonials-container');
    if (!container) return false;

    var scheduled = false;
    var refresh = function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update(container);
      });
    };

    update(container);
    new MutationObserver(refresh)
      .observe(container, { attributes: true, subtree: true, attributeFilter: ['class'], childList: true });
    window.matchMedia(MQ).addEventListener('change', refresh);
    return true;
  }

  /* The widget loads asynchronously — retry until it appears */
  var tries = 0;
  var timer = setInterval(function () {
    if (init() || ++tries > 50) clearInterval(timer);
  }, 300);
})();
